<template>
    <div class="w-100">
        <v-container fluid class="overflow-x-hidden overflow-hidden mt-1">
            <v-card>
                <v-row>
                    <!-- <v-col cols="3">
                        <v-autocomplete
                            v-model="filters.event_id"
                            @click="getSettings()"
                            :items="dropdowns.event_list"
                            label="Event Name"
                            item-text="name"
                            item-value="id"
                            color="#ffa500"
                            auto-select-first
                            outlined
                            dense
                        >
                        </v-autocomplete>
                    </v-col> -->
                    <v-spacer></v-spacer>
                    <v-col cols="1" class="text-end">
                        <v-tooltip bottom color="orange">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    @click="redirectToEvent()"
                                    v-bind="attrs"
                                    v-on="on"
                                    color="orange"
                                    text
                                >
                                    <v-icon>
                                        mdi-link-circle-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span style="color:black;">Redirect To Event</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="pa-0 ma-0">
                <v-card-title class="pa-0 ma-0">
                    <v-breadcrumbs :items="breadcrumbs">
                        <template v-slot:item="{ item }">
                        <v-breadcrumbs-item
                        @click="changeActive(item)"
                        :style="active_bread_crumb == item.text ? 'color:#ffa500' : 'color: #bcbcbc;'"
                        >
                            <span 
                                :style="active_bread_crumb == item.text ? 'color:#ffa500;' : 'color: #bcbcbc;'"
                                class="font_evog"
                            >{{ item.text.toUpperCase() }}</span>
                        </v-breadcrumbs-item>
                        </template>
                    </v-breadcrumbs>
                </v-card-title>

                <v-card-text>
                    <v-container>
                            <!-- <StatusSettingsContent v-if="active_bread_crumb == 'Status'"></StatusSettingsContent> -->
                            <RaffleSettingsComponent :event_id="filters.event_id" v-if="active_bread_crumb == 'Raffle'" />
                            <NominationSettingsComponent :event_id="filters.event_id" v-if="active_bread_crumb == 'Nomination & Voting'" />
                            <ExpansionSettingsComponent @raffleReset="raffleReset" :event_id="filters.event_id" v-if="active_bread_crumb == 'Expansions'" />
                            <PreferenceSettingsComponent :event_id="filters.event_id" v-if="active_bread_crumb == 'Event Preferences'" />
                    </v-container>
                </v-card-text>

                <v-card-actions class="text-center" style="border-top:1px solid #000000;">
                    <v-row class="ma-1 pb-2">
                        <v-col cols="4">
                            <v-container fluid class="d-flex justify-content-end pa-0">
                                <v-btn
                                    color="#ffa500"
                                    @click="saveSettings()"
                                >
                                    <span style="color:black;">Save Changes</span>
                                </v-btn>
                                <span class="pr-12">&nbsp;</span>
                            </v-container>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="4" v-if="user.super_admin">
                            <v-container fluid class="text-end pa-0">
                                <v-btn
                                    color="#ffa500"
                                    @click="triggerResetEvent(true)"
                                >
                                    <span style="color:black;">Reset Data</span>
                                </v-btn>
                                <span class="pr-12">&nbsp;</span>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-container>
        <v-dialog v-model="reset_data.dialog" persistent width="50%" :retain-focus="false">
            <v-card class="overflow-x-hidden">
                <v-card-title class="pa-3 pl-3 pb-0 border-bottom">
                    <span class="text-h5">Reset Event Details</span>
                    <v-row class="m-0">
                        <v-col cols="pull-right-10 p-2">
                            <v-btn
                                text
                                icon
                                small
                                color="gray"
                                class="float-right"
                                @click="triggerResetEvent(false)"
                            >
                                <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-container class="pb-0 mt-1" fluid>
                        <v-row no-gutters v-for="(item, i) in resetTables" :key="i">
                            <v-col cols="3" v-for="(data, index) in item.list" :key="index">
                                <v-checkbox
                                    v-model="reset_data.to_delete_tables"
                                    :label="data.text"
                                    :value="data.value"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions
                    class="text-center"
                >
                    <v-row class="ma-1 pb-2">
                        <v-col cols="12">
                            <v-btn
                                @click="resetDataNow()"
                            >
                                <span>Submit</span>
                            </v-btn>
                            <span class="pr-12">&nbsp;</span>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';
import RaffleSettingsComponent from '@/components/modules/settings/content/RaffleSettingsComponent.vue';
import NominationSettingsComponent from '@/components/modules/settings/content/NominationSettingsComponent.vue'
import ExpansionSettingsComponent from '@/components/modules/settings/content/ExpansionSettingsComponent.vue'
import PreferenceSettingsComponent from '@/components/modules/settings/content/PreferenceSettingsComponent.vue';

export default {
    data(){
        return {
            loaded: false,
            totalItems: 0,
            options: {},
            search: "",
            filter:{
                search:""
            },
            active_bread_crumb:'Raffle',
            userAccess: {
                view: false,
                create: false,
                edit: false,
                delete: false,
            },
            tab: null,
            items:[],
            breadcrumbs: [
                // {
                // text: 'Status',
                // disabled: false,
                // },
                {
                    text: 'Raffle',
                    disabled: true,
                },
                {
                    text: 'Nomination & Voting',
                    disabled: true,
                },
                {
                    text: 'Expansions',
                    disabled: false,
                },
                {
                    text: 'Event Preferences',
                    disabled: false,
                },
            ],
            settings_form:[],
            willReset: false,
            filters:{
                event_id: null,
            },
            dropdowns: {
                event_list: []
            },
            default: {
                event_id: 1
            },
            user: {},
            resetTables: [
                {
                    title: 'Statuses',
                    list:[
                        {text: 'Raffle Winners', value: 'raffle_winners'},
                        {text: 'Attendance', value: 'attendance'},
                        {text: 'Nomination', value: 'nomination'},
                    ]
                },
                {
                    title: 'Data',
                    list: [
                        {text: 'Guest List', value: 'guest_list'},
                        {text: 'Company List', value: 'company_list'},
                        {text: 'Company Tickets', value: 'company_tickets'},
                        {text: 'Share Your Moments', value: 'share_your_moments'},
                    ]
                }
            ],
            reset_data:{
                dialog: false,
                to_delete_tables: [
                    'raffle_winners',
                    'company_tickets',
                    'attendance',
                    'nomination',
                    'share_your_moments',
                    'guest_list',
                    'company_list',
                ]
            }
        }
    },
    components:{
        RaffleSettingsComponent,
        NominationSettingsComponent,
        ExpansionSettingsComponent,
        PreferenceSettingsComponent,
    },
    mounted(){
        // document.addEventListener("keydown", this.handleKeyDown);
        this.getEventDetailDropdown();
        this.setDefaults();
        this.getUser();
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.handleKeyDown);
    },
    computed:{
        ...mapGetters([
            'DIALOGS',
            'GET_FORM_SETTINGS',
            'GET_EVENT_ID'
        ])
    },
    methods:{
        bread_crumb_isActive(item){
            this.active_bread_crumb = item.value
        },
        saveSettings(){
            if(this.willReset){
                Swal.fire({
                    title: 'Are you sure you want to save?',
                    text: `Raffle winners will reset.`,
                    icon:'question',
                    showConfirmButton: true,
                    showCancelButton  :  true,
                }).then((action)=>{
                    if(action.isConfirmed){
                        this.triggerSave();
                    }
                })
            }else{
                this.triggerSave();
            }
        },
        viewHrSettings(item){
            this.$store.commit("HR_SETTINGS_VIEW", item);
            this.$store.commit("DIALOG", true);
            this.$store.commit("ACTION", "View");
        },
        editHrSettings(item){
            this.$store.commit("HR_SETTINGS_VIEW", item);
            this.$store.commit("DIALOG", true);
            this.$store.commit("ACTION", "Update");
        },
        initialForm(){
            this.settings_form = []
        },
        changeActive(item){
            this.active_bread_crumb = item.text
        },
        handleKeyDown(event) {
        // Check if Ctrl + S is pressed
            if (event.ctrlKey && event.key === "s") {
                event.preventDefault(); // Prevent default browser save behavior
                this.saveSettings();
            }
        },
        raffleReset(confirm) {
            this.willReset = confirm;
        },
        triggerSave(){
            let payload = {
                data : this.settings_form.data,
                type: this.settings_form.type,
                url: "moduleSettings",
                raffleReset: this.willReset,
                event_id: this.GET_EVENT_ID
            }
            this.$store.dispatch("urlPost", payload).then(response=>{
                Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
                this.$store.commit('NEW_DATA', true);
            })
        },
        getEventDetailDropdown(){
            let payload = {
                url: 'eventDetailDropdown'
            }
            this.$store.dispatch('urlGet', payload).then((res)=>{
                this.dropdowns.event_list = res.data;
            })
        },
        setDefaults(){
            Object.assign(this.filters,{
                event_id: this.default.event_id
            });
            // this.getSettings();
        },
        // getSettings(){
        //     this.$store.commit('EVENT_ID', this.filters.event_id);
        //     this.$store.commit('NEW_DATA', true);
        // },
        redirectToEvent(){
            let payload = {
                event_id: this.GET_EVENT_ID,
                url: 'getEventMD5'
            }
            this.$store.dispatch('urlPost', payload).then((res)=>{
                window.open(`${process.env.VUE_APP_API_HOST_CLIENT}?ec=${res.link}`)
            })
        },
        getUser(){
            let payload = {
                url: 'user'
            }
            this.$store.dispatch('urlGet', payload).then((res)=>{
                this.user = res;
            })
        },
        triggerResetEvent(value){
            this.reset_data.dialog = value;
            if(value){
                this.reset_data.to_delete_tables = [
                ]
            }
        },
        resetDataNow(){
            Swal.fire({
                title: 'Are you sure you want to reset?',
                text: `Event Related data will be cleared.`,
                icon:'question',
                showConfirmButton: true,
                showCancelButton  :  true,
            }).then((action)=>{
                if(action.isConfirmed){
                    let payload = {
                        url: "resetEventData",
                        event_id: this.GET_EVENT_ID,
                        to_delete: this.reset_data.to_delete_tables
                    }
                    this.$store.dispatch("urlPost", payload).then(response=>{
                        Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
                        this.$store.commit('NEW_DATA', true);
                    })
                }
            })
        }
    },
    watch:{
        options: {
            handler() {

            },
            deep: true,
        },
        GET_FORM_SETTINGS:{
            handler(val){
                this.settings_form = val
            },
            deep: true
        }
    }
}
</script>
<style scoped>
.selected {
    opacity: 100%;
}

.non-selected {
    opacity: 40%;
}
.v-breadcrumbs__item{
    cursor: pointer;
}

.font_evog{
    cursor:pointer; 
    font-family: Evogria;
}
</style>
